/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Hero_DescriptionInputs */

const en_why_listening_hero_description = /** @type {(inputs: Why_Listening_Hero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening turns articles, PDFs, documents and newsletters into natural audio. It skips the clutter other apps read aloud, and follows you to every device.`)
};

const es_why_listening_hero_description = /** @type {(inputs: Why_Listening_Hero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening convierte artículos, PDF, documentos y newsletters en audio natural. Omite el desorden que otras apps leen en voz alta y te acompaña en todos tus dispositivos.`)
};

/**
* | output |
* | --- |
* | "Listening turns articles, PDFs, documents and newsletters into natural audio. It skips the clutter other apps read aloud, and follows you to every device." |
*
* @param {Why_Listening_Hero_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_hero_description = /** @type {((inputs?: Why_Listening_Hero_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Hero_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_hero_description(inputs)
	return en_why_listening_hero_description(inputs)
});